module.exports = __webpack_public_path__ + "5ed80a9bf41c9dd3aeaeb01737c6e429.png";